import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const customerApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer",
      params,
    }),

  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
      method: "patch",
      data,
    }),

  verify: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/verify`,
      method: "post",
    }),

  unVerify: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/un-verify`,
      method: "delete",
    }),
};
